import styled from 'styled-components';

export const RangeSkeleton = styled.div`
  background-color: #f7f7f7;
  width: 100%;
  height: 4px;
  border-radius: 2px;
  position: relative;
  margin: 8px 0;

  &:before {
    content: '';
    width: 20px;
    height: 20px;
    border-radius: 100%;
    background: #f7f7f7;
    display: block;
    position: absolute;
    left: 20%;
    top: -8px;
  }
`;
